import React from "react";
import { Card, Progress, Tag, Button } from "antd";
import { CalendarOutlined } from "@ant-design/icons";


const ModuleProgressCard = ({ moduleData, percent=0, showProgress = true }) => 
  {
  const getStatusFromPercent = (percent, showProgress) => {
    if (!showProgress) return "Enrolled";     
    if (percent >= 100) return "Completed";     
    if (percent > 0) return "In Progress";      
    return "Not Started";   
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "In Progress":
        return "blue";
      case "Completed":
        return "green";
      case "Enrolled":
        return "default";
      default:
        return "gray";
    }
  };

  const displayStatus = getStatusFromPercent(percent, showProgress);
  const displayButton =
  percent >= 100 ? "View Certificate" : "Start";


  return (
    <div className="h-full overflow-x-scroll xl:overflow-x-hidden mb-2 mt-4">
        <Card className="rounded-2xl dark:bg-white/10">
          <div className="flex justify-between items-start mb-2">
            <div>
              <h3 className="text-base font-semibold text-gray-900 dark:text-white">
                {moduleData?.module_name}
              </h3>
            </div>

            <Tag
              color={getStatusColor(displayStatus)}
              className="rounded-full px-3 py-1 text-xs font-medium"
            >
              {displayStatus}
            </Tag>
          </div>

          {showProgress && (
            <div>
              <p className="text-sm text-gray-700 dark:text-gray-200">
                Progress
              </p>

              <div className="flex items-center">
                <Progress
                  percent={percent}
                  showInfo={false}
                  strokeColor={{
                    from: "#a855f7",
                    to: "#ec4899",
                  }}
                  className="flex-1"
                />
                <span className="text-sm font-semibold text-purple-600 ml-2">
                  {percent}%
                </span>
              </div>

            </div>
          )}  
          <Button
            block
            type="default"
            className="mt-2 rounded-xl border-gray-200 text-gray-700 font-medium !hover:bg-red-100 dark:text-gray-200 dark:hover:!bg-white/0"
            onClick={() => {
              window.location.href = `/console/training-modules/${moduleData?.tcm_module_id}/view`;
            }}
          >
            {displayButton}
          </Button>
        </Card>
    </div>
  );
};

export default ModuleProgressCard;
